import type { OperatorNodeProps } from "../operators/OperatorNode";
import { PortHandle } from "../PortHandle";
import dico from "../../../../util/src/language/dico";
import { timerReadPorts } from "../../../../util/src/behavior-timers/nodes";
import { useEffect } from "react";
import { OperatorNodeCard } from "../operators/OperatorNodeCard.js";

export function TimerReadNode({
  node,
  setPortsMap,
  onPortMouseDown,
  onPortMouseUp,
  isPortConnected,
  onPortValueChange,
  onTimerPortsChange,
}: OperatorNodeProps) {
  const labels = dico().behavior.timers;
  useEffect(() => {
    const missing = timerReadPorts(labels).filter(
      (p) => !node.ports.some((old) => old.id === p.id),
    );
    if (missing.length)
      onTimerPortsChange?.(node.id, [...node.ports, ...missing]);
  }, [node.id, node.ports, labels, onTimerPortsChange]);
  // Keep connected legacy outputs visible so existing layouts remain editable.
  const ports = [
    ...timerReadPorts(labels).map(
      (port) => node.ports.find((p) => p.id === port.id) ?? port,
    ),
    ...node.ports.filter(
      (p) =>
        p.direction === "output" &&
        !["value", "unit"].includes(p.id) &&
        isPortConnected?.(node.id, p.id),
    ),
  ];
  const renderPort = (p: (typeof ports)[number]) => (
    <PortHandle
      key={p.id}
      node={node}
      port={{
        ...p,
        label:
          p.id === "input1"
            ? labels.reference
            : (labels[p.id as keyof typeof labels] ?? p.label),
      }}
      setPortsMap={setPortsMap}
      onMouseDown={() => onPortMouseDown?.(node.id, p)}
      onMouseUp={() => onPortMouseUp?.(node.id, p)}
      isConnected={isPortConnected?.(node.id, p.id) ?? false}
      showValueInput={p.direction === "input"}
      showLabel
      onValueChange={(value) => onPortValueChange?.(node.id, p.id, value)}
    />
  );
  return (
    <OperatorNodeCard>
      <div>{ports.filter((p) => p.direction === "input").map(renderPort)}</div>
      <span
        style={{
          fontSize: 22,
          fontWeight: 600,
          textTransform: "uppercase",
          color: "#333333",
          padding: "0 20px",
          whiteSpace: "nowrap",
        }}
      >
        {labels.read}
      </span>
      <div>{ports.filter((p) => p.direction === "output").map(renderPort)}</div>
    </OperatorNodeCard>
  );
}
